/**
 * FH-A11Y batch 14 (2026-09-26): Contact form (Globo Form Builder).
 * The message box was labelled "Content", and every empty required field said the same generic
 * "Please fill in field"; a mistyped address said only "Invalid email". Errors now name the field
 * and say how to fix it. (The same text can also be set in Globo Form Builder; if it is, this does nothing.)
 * Rollback: remove the ada-a11y-batch14.js line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch14) return;
  window.__fhA11yBatch14 = true;

  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function fieldName(control) {
    var type = control.getAttribute('data-type');
    if (type === 'email') return 'email address';
    if (type === 'phone') return 'phone number';
    var l = txt(control.querySelector('.label-content'));
    return l ? l.toLowerCase() : 'this field';
  }

  var REWRITE = {
    'please fill in field': function (c) { return 'Please enter your ' + fieldName(c) + '.'; },
    'invalid email': function () { return 'Please enter a valid email address, for example name@example.com.'; },
    'invalid phone': function () { return 'Please enter a valid phone number.'; },
    'invalid name': function () { return 'Please enter a valid name.'; },
    'invalid': function (c) { return 'Please check your ' + fieldName(c) + '.'; }
  };

  function fixMessage(box) {
    var control = box.closest('.globo-form-control');
    if (!control) return;
    box.querySelectorAll('.help-block, p').forEach(function (p) {
      var f = REWRITE[txt(p).toLowerCase()];
      if (!f) return;
      var t = f(control);
      if (p.textContent !== t) p.textContent = t;
    });
  }

  function fixForms() {
    document.querySelectorAll('.globo-form-control').forEach(function (control) {
      /* "Content" -> "Message" for the message box. */
      if (control.getAttribute('data-type') === 'textarea') {
        var lc = control.querySelector('.label-content');
        if (lc && txt(lc) === 'Content') lc.textContent = 'Message';
      }
      var box = control.querySelector('.messages');
      if (!box) return;
      fixMessage(box);
      if (box.__fh14) return;
      box.__fh14 = true;
      /* Rewrite before the change is rendered, so screen readers only hear the clear message. */
      new MutationObserver(function () { fixMessage(box); })
        .observe(box, { childList: true, subtree: true, characterData: true });
    });
  }

  var timer = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; try { fixForms(); } catch (e) {} }, 60);
  }

  function start() {
    try { fixForms(); } catch (e) {}
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
